import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Button } from '@mui/material'
import { reportError } from 'utils/errorReporter'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Expansible } from 'components/Expansible'
import { PROCESS_STATUS } from 'utils/constants/kypStatuses'
import BgcScoreExpansibleTitle from 'components/BgcScoreExpansibleTitle'
import styles from './styles'
import { BGC_FIELDS } from '../../../utils/constants/bgcFields'
import BgcExpansible from '../BgcExpansible'
import BuildBGCScoreBoard from '../BuildBGCScoreBoard'

function ExpandableBackgroundCheck({ backgroundCheck }) {
  const classes = styles()

  const [onlyShowConsists, setOnlyShowConsists] = useState(false)

  const excludedFields = [
    BGC_FIELDS.risk_score,
    BGC_FIELDS.credit_score_data,
    BGC_FIELDS.financial_pendings_data,
  ]

  const findScore = (type) => {
    const scoreData = backgroundCheck?.score_board?.score_data
    return scoreData[type] || null
  }

  const isProcessed = (field, data) => {
    if (field === 'compliance_list') {
      return true
    }

    if (data == null) {
      return false
    }
    if (data.status === undefined) {
      return true
    }
    return data.status === 'PROCESSED'
  }

  const doesConsists = (field, data, scoreData) => {
    if (field === 'compliance_list') {
      return data !== null
    }

    if (field === 'family_relation_data') {
      return data?.has_conflicting_relatives
    }
    
    if (field === 'financial_situation') {
      if (data.credit_score_data?.quod_score < 700) {
        return true
      }

      return data.financial_pendings_data?.has_pendings
    }


    if (scoreData != null) {
      return scoreData.value > 0
    }

    if (data == null) {
      return false
    }
    if (data.consists === undefined) {
      return true
    }
    return data.consists
  }

  const renderItem = (field, bgcItem, score_data, consists, processed) => {
    return (
      <div
        key={backgroundCheck ? `${field}_${backgroundCheck.uuid}` : uuidv4()}
        className={classes.bgc}
      >
        <BgcExpansible
          field={field}
          bgc_info={bgcItem}
          score_data={score_data}
          processed={processed}
          consists={consists}
        />
      </div>
    )
  }

  
  return (
    <React.Fragment>
      {backgroundCheck?.status === PROCESS_STATUS.PROCESSED && (
        <React.Fragment>
          <Expansible
            open={false}
            title={
              <BgcScoreExpansibleTitle finalScore={backgroundCheck?.score_board?.final_score} />
            }
          >
            <BuildBGCScoreBoard scoreBoardData={backgroundCheck?.score_board} />
          </Expansible>
          <br></br>
        </React.Fragment>
      )}

      {backgroundCheck?.score_board?.final_score > 0 && (
        <div className={classes.onlyShowConsistsBtnDiv}>
          <Button
            variant="outlined"
            size="small"
            startIcon={onlyShowConsists ? <Visibility /> : <VisibilityOff />}
            onClick={() => setOnlyShowConsists(!onlyShowConsists)}
          >
            {onlyShowConsists ? 'Mostrar tudo' : 'Mostrar somente apontamentos'}
          </Button>
        </div>
      )}

      {Object.values(BGC_FIELDS).map((field) => {
        try {
          if (!excludedFields.includes(field)) {
            let score_data

            if (field === BGC_FIELDS.financial_situation) {
              score_data = findScore(BGC_FIELDS.financial_pendings_data)
            } else {
              score_data = findScore(field)
            }

            const bgcItem = backgroundCheck ? backgroundCheck[field] : null
            const consists = doesConsists(field, bgcItem, score_data)
            const processed = isProcessed(field, bgcItem)
            return (
              (!onlyShowConsists || consists) &&
              renderItem(field, bgcItem, score_data, consists, processed)
            )
          }
          return null
        } catch (err) {
          reportError(err, 'ExpandableBackgroundCheck', backgroundCheck)
          
          return (
            <div className={classes.errorCaptured}>
              <span>Ocorreu um erro ao tratar os dados</span>
            </div>
          )
        }
      })}
    </React.Fragment>
  )
}

export default ExpandableBackgroundCheck
